import { CustomerType, CustomerTypeLabels, DivisionId, DivisionIdLabels } from './types';

export const CUSTOMER_TYPE: { [K in CustomerTypeLabels]: CustomerType } = {
  RESIDENTIAL: 'residential',
  BUSINESS: 'business',
};

export const DIVISION_ID: { [K in DivisionIdLabels]: DivisionId } = {
  ELECTRICITY: '01',
  GAS: '02',
  HOT_WATER: '03',
  LPG: '90',
  SOLAR: 'SO',
  OHM: 'OHM',
};
